import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useProfile } from '../hooks/useProfile'

interface LayoutProps {
  children: React.ReactNode
  /** Optional content to render in the header bar (e.g., page-specific actions) */
  headerActions?: React.ReactNode
}

export default function Layout({ children, headerActions }: LayoutProps) {
  const { user, signOut } = useAuth()
  const { profile, loading } = useProfile()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await signOut()
    navigate('/login')
  }

  const isAdmin = profile?.account_type === 'admin' || profile?.account_type === 'global_admin'

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Fixed navigation header */}
      <nav className="bg-primary shadow fixed top-0 left-0 right-0 z-50 overflow-visible">
        <div className="w-full px-4 sm:px-6 lg:px-8 overflow-visible">
          <div className="flex justify-between h-16 overflow-visible">
            <div className="flex items-center space-x-8">
              <Link to="/" className="text-xl font-header font-semibold text-white hover:text-gray-200">
                IntelliTrack
              </Link>
              {isAdmin && (
                <Link to="/users" className="text-white hover:text-gray-200 text-sm font-medium">
                  Users
                </Link>
              )}
            </div>
            <div className="flex items-center space-x-4">
              {/* Page-specific header actions */}
              {headerActions}
              <span className="text-white text-sm">
                {loading ? 'Loading...' : (profile?.display_name || user?.email)}
              </span>
              <button
                onClick={handleSignOut}
                className="bg-secondary text-gray-800 hover:bg-orange-400 px-3 py-2 rounded-md text-sm font-medium"
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
      </nav>
      {/* Spacer to prevent content from being hidden under fixed nav */}
      <div className="h-16" />
      {children}
    </div>
  )
}